import { PaidStatus } from './league';

import { User } from '.';

export interface TeamUser extends User {
  captain: TeamRoleStatus;
  scheduler: TeamRoleStatus;
  manager: TeamRoleStatus;
  league_roster?: number;
  paid?: PaidStatus;
}

export enum TeamRoleStatus {
  No = 0,
  Yes = 1,
}
